import { useRecoilValue } from 'recoil';
import { useHippoText } from '../../hooks/useHippoText';
import { customerBenefitsSelector } from '../../recoil/selectors/customerBenefitsSelector';
import CustomerBenefitText from '../CustomerBenefitText/CustomerBenefitText';

const CustomerBenefit = ({
    interactive = true,
    shouldRenderShoppingBasketDesign = false
}: {
    interactive?: boolean;
    shouldRenderShoppingBasketDesign?: boolean;
}): React.JSX.Element => {
    const { benefits } = useRecoilValue(customerBenefitsSelector);
    const getHippoText = useHippoText();
    const healthWithAgreementText = getHippoText(
        'DSS-CUSTOMER-COLLECTION-DISCOUNT-SUNDHEDSHJÆLP_WITH_AGREEMENT_DESCRIPTION'
    );
    const healthWithoutAgreementText = getHippoText(
        'DSS-CUSTOMER-COLLECTION-DISCOUNT-SUNDHEDSHJÆLP_WITHOUT_AGREEMENT_DESCRIPTION'
    );

    const benefitsAndAgreementsDescriptionMap: Record<string, string> = {
        Sundhedshjælp:
            benefits?.length === 1 ? healthWithoutAgreementText : healthWithAgreementText,
        Samlerabat: getHippoText('DSS-CUSTOMER-COLLECTION-DISCOUNT-SAMLERABAT_DESCRIPTION'),
        Nordea: getHippoText('DSS-CUSTOMER-COLLECTION-DISCOUNT-NORDEA_DESCRIPTION'),
        NærBrand: getHippoText('DSS-CUSTOMER-COLLECTION-DISCOUNT-NÆRBRAND_DESCRIPTION'),
        Norlys: getHippoText('DSS-CUSTOMER-COLLECTION-DISCOUNT-NORDLYS_DESCRIPTION')
    };

    const otherCompanyAgreementDescription = getHippoText(
        'DSS-CUSTOMER-COLLECTION-DISCOUNT-OTHERCOMPANY_DESCRIPTION'
    );
    if (!benefits || benefits.length === 0) {
        return <></>;
    }

    const getBenefitOrAgreementDescription = (benefitType: string): string => {
        if (benefitsAndAgreementsDescriptionMap[benefitType]) {
            return benefitsAndAgreementsDescriptionMap[benefitType];
        } else {
            return `${otherCompanyAgreementDescription} ${benefitType}`;
        }
    };

    return (
        <div
            className={
                shouldRenderShoppingBasketDesign
                    ? 'u-flex-box u-flex-box--col u-gap-3'
                    : 'u-spacing-inset-l--stretch-max '
            }
        >
            <p
                className={
                    shouldRenderShoppingBasketDesign
                        ? 'h4 u-spacing-stack-bottom-none'
                        : 'h6 u-spacing-stack-xs'
                }
            >
                {getHippoText('DSS-CUSTOMER-BENEFITS')}
            </p>
            {benefits?.map((benefitType) => {
                return (
                    <CustomerBenefitText
                        key={benefitType}
                        interactive={interactive}
                        title={benefitType}
                        description={getBenefitOrAgreementDescription(benefitType)}
                        shouldRenderShoppingBasketDesign={shouldRenderShoppingBasketDesign}
                    />
                );
            })}
        </div>
    );
};

export default CustomerBenefit;
